import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';

import BrainRouteView from './pages/BrainRouteView.vue';
import BrainAssistantsIndexPage from './pages/BrainAssistantsIndexPage.vue';

// Lazy-load page components
const BrainFaqsIndex = () => import('./faqs/Index.vue');
const BrainFaqsPending = () => import('./faqs/Pending.vue');
const BrainKnowledgeIndex = () => import('./knowledge/Index.vue');
const BrainKnowledgePending = () => import('./knowledge/Pending.vue');
const BrainInboxesIndex = () => import('./inboxes/Index.vue');
const BrainSettingsIndex = () => import('./settings/Settings.vue');
const BrainDataManagerSettings = () => import('./dataManager/Settings.vue');

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.BRAIN,
};

const dataManagerMeta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.BRAIN,
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/brain/:assistantId/faqs'),
    component: BrainFaqsIndex,
    name: 'brain_assistants_faqs_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/brain/:assistantId/faqs/pending'),
    component: BrainFaqsPending,
    name: 'brain_assistants_faqs_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/brain/:assistantId/knowledge'),
    component: BrainKnowledgeIndex,
    name: 'brain_assistants_knowledge_index',
    meta,
  },
  {
    path: frontendURL(
      'accounts/:accountId/brain/:assistantId/knowledge/pending'
    ),
    component: BrainKnowledgePending,
    name: 'brain_assistants_knowledge_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/brain/:assistantId/inboxes'),
    component: BrainInboxesIndex,
    name: 'brain_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/brain/:assistantId/settings'),
    component: BrainSettingsIndex,
    name: 'brain_assistants_settings_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/brain/:assistantId/data-manager'),
    component: BrainDataManagerSettings,
    name: 'brain_assistants_data_manager_settings',
    meta: dataManagerMeta,
  },
  {
    path: frontendURL('accounts/:accountId/brain/:navigationPath'),
    component: BrainAssistantsIndexPage,
    name: 'brain_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/brain'),
    component: BrainRouteView,
    redirect: to => ({
      name: 'brain_assistants_index',
      params: {
        navigationPath: 'brain_assistants_faqs_index',
        ...to.params,
      },
    }),
    children: [...assistantRoutes],
  },
];
